module.exports = __webpack_public_path__ + "static/media/facebook_icon.016917a1.svg";